import React, { useState } from 'react'
import DynamicItemViewPage from '../admin/DynamicItemViewPage'
import { useDispatch } from 'react-redux'
import { deleteItem } from '../items/itemsSlice'
import ItemsBasePage from '../items/ItemsBasePage'
import { useParams } from 'react-router-dom'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import ItemsApp from '../items/ItemsApp'
import { saveAs } from "file-saver"
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { handleRequestError } from '../../services/api'
import WarehouseSectionsList from './WarehouseSectionsList'

interface IViewSingleWarehousePageProps {
    customId?: number,
}

export default function ViewSingleWarehousePage(props: IViewSingleWarehousePageProps) {

    const {
        customId
    } = props

    const dispatch = useDispatch()

    const params = useParams()
    const warehouseId = customId ? customId : params.id ? Number(params.id) : 0

    const [loading, setLoadig] = useState<boolean>(false)

    const itemsApp = new ItemsApp()

    const exportItems = () => {
        setLoadig(true)

        itemsApp.exportItems("warehouse_items", [], warehouseId)
            .then(response => {
                setLoadig(false)
    
                const blob = response.data;

                const contentDisposition = response.headers["content-disposition"]
                let fileName = "exported_items.xlsx"

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/)
                    if (match && match[1]) {
                        fileName = match[1]
                    }
                }
    
                saveAs(blob, fileName)
    
                updateQuickNotificationDetails(true, "The items have been exported successfully!", "success", dispatch);
            })
            .catch(error => {
                setLoadig(false)
                handleRequestError(error, dispatch);
            }); 
    }

    const additionalContent = () => {
        return(
            <div className="action-buttons-of-section-box-admin-panel">
                <div className="content-of-action-buttons-of-section-box-admin-panel">

                    <LoadingButton loading={loading} onClick={() => exportItems()} className="general-button admin-style light-button" color="success" variant="contained">Export Items</LoadingButton>

                </div>
            </div>
        )
    }

    return(
        <div>
            <DynamicItemViewPage additionalContent={additionalContent} customPage="warehouses" customId={customId} />

            {warehouseId && (
                <div className="warehouse-sections-single-page-container">
                    <SectionBoxContainer showTitle title="Warehouse Sections">
                        <WarehouseSectionsList warehouseId={warehouseId} />
                    </SectionBoxContainer>
                </div>
            )}
            
            <div className="items-viewer-with-section-box-container">
                <SectionBoxContainer showTitle title="Warehouse Items">
                    <ItemsBasePage isInventoryPage dashboardPage customWarehouseId={warehouseId} disableSectionBoxContainer />
                </SectionBoxContainer>
            </div>
        </div>
    )

}